let HTTP_URL = process.env.VUE_APP_ENV == 'test' ? 'http://47.97.243.140:8081' : 'https://api.thecover.cn';
let ACTIVITY_URL = process.env.VUE_APP_ENV == 'test' ? 'https://actapi.thepage.cn' : 'https://actapi.thepage.cn';

export default {
    //安卓下载apk地址
    DOWNLOAD_ADDRESS: 'https://api.thecover.cn/download.js',
    //scheme地址
    APP_SCHEME_URL: 'cover://cn.thecover.www',
    //微信里面scheme地址
    WEIXIN_APP_SCHEME_URL: 'http://0.0.0.0:22021',
    //UniversalLink地址
    UNIVERSALLINK: 'https://wapcdn.thecover.cn/UniversalLinks/index.html',
    //封面新闻接口地址
    HTTP_URL,
    //活动接口地址 
    ACTIVITY_URL,
    // 七牛图片服务器地址
    QINIUDOMAIN: 'http://7xte9b.com2.z0.glb.qiniucdn.com/',
    //微信应用宝地址
    WEXIN_APP_DOWNLOAD_ADDRESS: "http://a.app.qq.com/o/simple.jsp?pkgname=cn.thecover.www.covermedia",
    ApiToken: sessionStorage.getItem('TOKEN'),
    Api_sign_root: '12345678',
    wx_appid: 'wx1294924fd43f1119',
    //当前时间戳
    timestamp: new Date().getTime(),
}
